// Vendor
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Swipe from 'react-easy-swipe';
// Components
import Button from 'components/Button';
import Spinner from 'components/Spinner';

// Root Styles
import '../../styles/document.styl';
// Styles
import './style.styl';

const content = [
  {
    tab: 'Искать инсайты',
    pages: [
      {
        img: '/static/images/Onboarding/img_approved-insights.png',
        headline: 'Проверенные инсайты',
        text:
          'Мы сделали этот сервис, чтобы ты пользовался базой проверенных инсайтов и тестировал гипотезы на своём продукте.',
      },
      {
        img: '/static/images/Onboarding/img_filter.png',
        headline: 'Удобная фильтрация',
        text:
          'Мы позаботились о том, чтобы у тебя была простая навигация. Используй фильтр для поиска нужной публикации.',
      },
      {
        img: '/static/images/Onboarding/img_details.png',
        headline: 'Полезные подробности',
        text:
          'Читай инсайты полностью: в каждой строчке есть полезная информация, а самое интересное может быть в конце. ',
      },
      {
        img: '/static/images/Onboarding/img_networking.png',
        headline: 'Нетворкинг в комментариях ',
        text:
          'Задавай вопросы в комментариях, знакомься с авторами, находи единомышленников, обменивайся c ними опытом.',
      },
      // {
      //   img: '/static/images/Onboarding/img_favorites.png',
      //   headline: 'Коллекция идей',
      //   text: 'Ни одна идея не потеряется в ленте. Сохраняй любимые инсайты в «Избранное» и используй эту коллекцию в работе.',
      // },
    ],
  },
  {
    tab: 'Делиться опытом',
    pages: [
      {
        img: '/static/images/Onboarding/img_constructor.gif',
        headline: 'Конструктор инсайтов',
        text:
          'Собери вывод по инсайту в нашем простом конструкторе и расскажи всем, как получился такой результат.',
      },
      {
        img: '/static/images/Onboarding/img_create.gif',
        headline: 'Как создать инсайт',
        text:
          'Получай лайки к своим инсайтам от профессионалов из разных сфер. Общайся с ними в комментариях и обменивайся полезным опытом.',
      },
      {
        img: '/static/images/Onboarding/img_portfolio.gif',
        headline: 'Портфолио инсайтов',
        text:
          'Все твои инсайты хранятся на личной странице. Можно делиться ссылками на весь профиль или на один инсайт с работодателями, коллегами, друзьями.',
      },
    ],
  },
  // {
  //   tab: 'Делиться опытом',
  //   pages: [
  //     {
  //       id: '0',
  //       video: 'https://player.vimeo.com/video/307693258',
  //       videoHeadline: 'Как создать инсайт',
  //       headline: 'Конструктор инсайтов',
  //       text:
  //         'Собери вывод по инсайту в нашем простом конструкторе и расскажи всем, как получился такой результат.',
  //     },
  //     {
  //       id: '1',
  //       video: 'https://player.vimeo.com/video/307693456',
  //       videoHeadline: 'Как создать инсайт',
  //       headline: 'Нетворкинг в комментариях',
  //       text:
  //         'Получай лайки к своим инсайтам от профессионалов из разных сфер. Общайся с ними в комментариях и обменивайся полезным опытом.',
  //     },
  //     {
  //       id: '2',
  //       video: 'https://player.vimeo.com/video/307693546  ',
  //       videoHeadline: 'Как создать инсайт',
  //       headline: 'Портфолио инсайтов',
  //       text:
  //         'Все твои инсайты хранятся на личной странице. Можно делиться ссылками на весь профиль или на один инсайт с работодателями, коллегами, друзьями.',
  //     },
  //   ],
  // },
];

const durationOndordingDisapear = 500;

class Onboarding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0,
      activePage: 0,
      isPlayngVideo: false,
    };
  }

  componentDidMount = () => {
    const onboarding = this.refs.onboarding;
    const popup = this.refs.popup;
    onboarding.style.transition = 'opacity .3s';
    popup.style.transition = `transform ${0.001 *
      durationOndordingDisapear}s cubic-bezier(0.645, 0.045, 0.355, 1)`;
    setTimeout(() => {
      onboarding.style.opacity = 1;
    }, 0);

    this.initVideo();

    const { tab } = this.props;
    if (tab) {
      let activeTab;
      if (tab === '#onboarding-find') {
        activeTab = 0;
      }
      if (tab === '#onboarding-share') {
        activeTab = 1;
      }
      this.setState({
        activeTab,
      });
    }
  };
  componentDidUpdate = () => {
    this.initVideo();
  };

  initVideo = () => {
    content[1].pages.map((elem, index) => {
      if (elem.video) {
        var iframe = this.refs[`video-${elem.id}`];
        if (iframe) {
          const vimeoPost = (action, value, target) => {
            var data = { method: action };
            if (value) {
              data.value = value;
            }
            target.postMessage(JSON.stringify(data), '*');
          };

          window.addEventListener(
            'message',
            event => {
              /* Get message and sender from the event */
              var message = JSON.parse(event.data);
              var sender = event.source;

              if (message.event == 'ready') {
                vimeoPost('addEventListener', 'play', sender);
                vimeoPost('addEventListener', 'pause', sender);
              }

              if (message.event == 'play') {
                this.setState({
                  isPlayngVideo: true,
                });
              }
            },
            false,
          );

          // var player = new Vimeo.Player(iframe);
          // player.on('play', () => {
          //   console.log('paly!');
          //   this.setState({
          //     isPlayngVideo: true,
          //   });
          // });
        }
      }
    });
  };
  closeVideo = () => {
    content[1].pages.map((elem, index) => {
      if (elem.video) {
        var iframe = this.refs[`video-${elem.id}`];
        if (iframe) {
          var player = new Vimeo.Player(iframe);
          player.pause();
          this.setState({
            isPlayngVideo: false,
          });
        }
      }
    });
  };

  changeTab = index => {
    if (index >= 0 && index <= content.length - 1) {
      this.setState({
        activeTab: index,
        activePage: 0,
      });
    }
  };

  changePage = index => {
    const { activeTab } = this.state;
    if (index >= 0 && index <= content[activeTab].pages.length - 1) {
      this.setState({
        activePage: index,
      });
    }
  };
  nextPage = () => {
    const { activeTab } = this.state;
    const targetPage = Math.min(++this.state.activePage, content[activeTab].pages.length - 1);
    this.changePage(targetPage);
  };
  prevPage = () => {
    const targetPage = Math.max(--this.state.activePage, 0);
    this.changePage(targetPage);
  };

  close = () => {
    // Анимация сворачивания попапа в пункт меню
    // Окно попапа и нужный пункт меню:
    const onboarding = this.refs.onboarding;
    const popup = this.refs.popup;
    const menuItem = document.getElementsByClassName('Header__link_about')[0];
    // Их размеры:
    const widthPopup = popup.offsetWidth;
    const heightPopup = popup.offsetHeight;
    const widthMenuItem = menuItem.offsetWidth;
    const heightMenuItem = menuItem.offsetHeight;
    // Их координаты:
    const xMenuItem = menuItem.getBoundingClientRect().left;
    const yMenuItem = menuItem.getBoundingClientRect().top;
    const xPopup = popup.getBoundingClientRect().left;
    const yPopup = popup.getBoundingClientRect().top;
    // Необходимый сдвиг попапа:
    const xOffsset = xMenuItem - xPopup;
    const yOffsset = yMenuItem - yPopup;
    // Коэффициент масштабирования попапа:
    const xScale = widthMenuItem / widthPopup;
    const yScale = heightMenuItem / heightPopup;

    onboarding.style.transition = `opacity ${0.001 * durationOndordingDisapear}s ${0.5 *
      0.001 *
      durationOndordingDisapear}s`;
    if (document.documentElement.clientWidth > 1023) {
      // На десктопе сворачиваем попап непосредственно в пункт меню (а на мобилке просто уводим в опасити)
      popup.style.transform = `translate(${xOffsset}px, ${yOffsset}px) scale(${xScale}, ${yScale})`;
    }
    onboarding.style.opacity = 0;

    setTimeout(() => {
      this.props.onClose();
    }, durationOndordingDisapear);
  };

  render() {
    const { className } = this.props;
    const { activeTab, activePage, isPlayngVideo } = this.state;

    const img = content[activeTab].pages[activePage].img;
    const headline = content[activeTab].pages[activePage].headline;
    const text = content[activeTab].pages[activePage].text;
    const isFirstPage = activePage === 0;
    const isLastPage = activePage === content[activeTab].pages.length - 1;
    const classAsideLeft = cn({
      'Onboarding__aside-left': true,
      'Onboarding__aside-left_extended': isPlayngVideo,
    });
    const classAsideRight = cn({
      'Onboarding__aside-right': true,
      'Onboarding__aside-right_hidden': isPlayngVideo,
    });

    return (
      <div className="Onboarding" ref="onboarding">
        <div className="Onboarding__bg" onClick={this.close} />
        <div className="Onboarding__popup" ref="popup">
          <div className={classAsideLeft}>
            <Spinner size={30} />
            {content.map((elem, indexTab) => {
              return content[indexTab].pages.map((elem, index) => {
                if (elem.img) {
                  const blockClass = cn({
                    Onboarding__image: true,
                    Onboarding__image_active: index === activePage && activeTab === indexTab,
                  });
                  return <img key={index} className={blockClass} src={elem.img} />;
                } else if (elem.video) {
                  const blockClass = cn({
                    Onboarding__video: true,
                    Onboarding__video_active: index === activePage && activeTab === indexTab,
                    Onboarding__video_extended: isPlayngVideo,
                  });
                  return (
                    <div key={index} className={blockClass}>
                      {isPlayngVideo && (
                        <div className="Onboarding__video-header">
                          <div className="Onboarding__video-headline">{elem.videoHeadline}</div>
                          <div
                            className="Onboarding__close Onboarding__close_video"
                            onClick={this.closeVideo}
                          />
                        </div>
                      )}
                      <iframe
                        ref={`video-${elem.id}`}
                        key={index}
                        className={blockClass}
                        src={elem.video}
                        width={isPlayngVideo ? 795 : 295}
                        height={isPlayngVideo ? 435 : 162}
                        frameBorder="0"
                        allowFullScreen
                        webkitallowfullscreen="true"
                        mozallowfullscreen="true"
                      />
                      {!isPlayngVideo && elem.videoText && (
                        <div className="Onboarding__video-text">{elem.videoText}</div>
                      )}
                    </div>
                  );
                }
              });
            })}
          </div>
          <div className={classAsideRight}>
            <Swipe onSwipeRight={this.prevPage} onSwipeLeft={this.nextPage}>
              {!isPlayngVideo && (
                <div className="Onboarding__header">
                  <div className="Onboarding__tabs">
                    {content.map((elem, index) => {
                      const blockClass = cn({
                        Onboarding__tab: true,
                        Onboarding__tab_active: index === activeTab,
                      });
                      return (
                        <div
                          key={index}
                          className={blockClass}
                          onClick={() => {
                            this.changeTab(index);
                          }}>
                          {elem.tab}
                        </div>
                      );
                    })}
                  </div>
                  <div className="Onboarding__close Onboarding__close_desktop" onClick={this.close}>
                    Пропустить
                  </div>
                  <div
                    className="Onboarding__close Onboarding__close_mobile"
                    onClick={this.close}
                  />
                </div>
              )}
              <div className="Onboarding__content">
                <div className="Onboarding__content-img">
                  {content.map((elem, indexTab) => {
                    return content[indexTab].pages.map((elem, index) => {
                      if (elem.img) {
                        const blockClass = cn({
                          Onboarding__image: true,
                          Onboarding__image_active: index === activePage && activeTab === indexTab,
                        });
                        return <img key={index} className={blockClass} src={elem.img} />;
                      } else if (elem.video) {
                        const blockClass = cn({
                          Onboarding__video: true,
                          Onboarding__video_active: index === activePage && activeTab === indexTab,
                          Onboarding__video_extended: isPlayngVideo,
                        });
                        return (
                          <div key={index} className={blockClass}>
                            {isPlayngVideo && (
                              <div className="Onboarding__video-header">
                                <div className="Onboarding__video-headline">
                                  {elem.videoHeadline}
                                </div>
                                <div
                                  className="Onboarding__close Onboarding__close_video"
                                  onClick={this.closeVideo}
                                />
                              </div>
                            )}
                            <iframe
                              ref={`video-${elem.id}`}
                              key={index}
                              className={blockClass}
                              src={elem.video}
                              width={isPlayngVideo ? '100%' : 160}
                              height={isPlayngVideo ? 435 : 88}
                              frameBorder="0"
                              allowFullScreen
                              webkitallowfullscreen="true"
                              mozallowfullscreen="true"
                            />
                            {!isPlayngVideo && (
                              <div className="Onboarding__video-text">{elem.videoText}</div>
                            )}
                          </div>
                        );
                      }
                    });
                  })}
                </div>
                {!isPlayngVideo && <div className="Onboarding__headline">{headline}</div>}
                {!isPlayngVideo && <div className="Onboarding__text">{text}</div>}
              </div>
              {!isPlayngVideo && (
                <div className="Onboarding__footer">
                  <div className="Onboarding__paginator">
                    {content[activeTab].pages.map((elem, index) => {
                      const blockClass = cn({
                        Onboarding__page: true,
                        Onboarding__page_active: index === activePage,
                      });
                      return (
                        <div
                          key={index}
                          className={blockClass}
                          onClick={() => {
                            this.changePage(index);
                          }}
                        />
                      );
                    })}
                  </div>
                  <div className="Onboarding__controls">
                    {!isFirstPage && (
                      <Button
                        type="button"
                        dir="back"
                        className="Onboarding__back"
                        onClick={this.prevPage}
                      />
                    )}
                    <span />
                    <Button
                      className="Onboarding__forward"
                      dir="forward"
                      onClick={!isLastPage ? this.nextPage : this.close}>
                      {!isLastPage ? 'Дальше' : 'Всё понятно'}
                    </Button>
                  </div>
                </div>
              )}
            </Swipe>
          </div>
        </div>
      </div>
    );
  }
}

Onboarding.defaultProps = {
  className: '',
};

Onboarding.propTypes = {
  className: PropTypes.string,
  tab: PropTypes.string,
};

export default Onboarding;



// WEBPACK FOOTER //
// components/Onboarding/index.js